import { DebouncedTextField } from 'components/DebouncedTextField'
import { useIntl } from 'react-intl'
import { MAX_YT_TITLE_LENGTH } from 'shared/constants'
import { ComposerYoutubePost } from 'shared/types'
import styles from './BulkPost.pcss'

interface BulkPostYoutubeStatusProps {
  post: ComposerYoutubePost
  onTitleChange: (value: string) => void
  onDescriptionChange: (value: string) => void
}
export function BulkPostYoutubeStatus({ post, onTitleChange, onDescriptionChange }: BulkPostYoutubeStatusProps) {
  const intl = useIntl()

  return (
    <div className={styles.pin}>
      <div className={styles['pin-input-row']}>
        <DebouncedTextField
          value={post.title}
          multiline
          placeholder={intl.formatMessage({ id: 'composer.labels.youtube-title-placeholder' })}
          classes={{ root: styles['title-box'] }}
          slotProps={{
            formHelperText: {
              className: styles.helper
            }
          }}
          maxLength={MAX_YT_TITLE_LENGTH}
          onTextChange={onTitleChange}
        />
      </div>
      <div className={styles['pin-input-row']}>
        <DebouncedTextField
          value={post.description}
          multiline
          placeholder={intl.formatMessage({ id: 'composer.labels.youtube-description-placeholder' })}
          className={styles['description-box']}
          slotProps={{
            input: {
              classes: {
                root: styles['description-input']
              }
            },
            formHelperText: {
              className: styles.helper
            }
          }}
          onTextChange={onDescriptionChange}
        />
      </div>
    </div>
  )
}
